import { Typography, TypographyProps } from "@mui/material";
import React from "react";

const TypographyWrapper: React.FC<TypographyProps> = ({ ...props }) => (
  <Typography {...props} />
);

export default TypographyWrapper;
